class TabRouter {
  isBack = false
  vueRouter = null
  preFullPathMap = {}
  sessionKey = `preFullPathMap_${ window.fe.project }`
  constructor (vueRouter) {
    this.vueRouter = vueRouter
    const preFullPathMapStore = JSON.parse(sessionStorage.getItem(this.sessionKey))
    if (preFullPathMapStore) this.preFullPathMap = preFullPathMapStore
  }
  back () {
    this.isBack = true
    const currentRoute = this.vueRouter.history.current
    if (this.preFullPathMap[currentRoute.path]) {
      this.vueRouter.replace(this.preFullPathMap[currentRoute.path])
      this.preFullPathMap[currentRoute.path] = null
      this.updatePreFullPathMapStore()
    } else {
      window.console.warn('no pre path, so go $router.back()')
      this.vueRouter.back()
    }
  }
  record (currentRoute, preRoute) {
    if (!preRoute) {
      return
    }
    this.preFullPathMap[currentRoute.path] = preRoute.fullPath
    this.updatePreFullPathMapStore()
  }
  resetIsBack () {
    this.isBack = false
  }
  updatePreFullPathMapStore () {
    sessionStorage.setItem(this.sessionKey, JSON.stringify(this.preFullPathMap))
  }
  reset () {
    this.preFullPathMap = {}
    this.updatePreFullPathMapStore()
  }
}

export default TabRouter
